import { render, staticRenderFns } from "./ProjectEditComponent.vue?vue&type=template&id=08da8b05&scoped=true"
import script from "./ProjectEditComponent.vue?vue&type=script&lang=js"
export * from "./ProjectEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectEditComponent.vue?vue&type=style&index=0&id=08da8b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da8b05",
  null
  
)

export default component.exports